/* eslint-disable import/no-restricted-paths */
/**
 * Offers
 */

import { IHighwayItemPresenterSchema } from '../../../node/repositories/agent-card/entities/highway_item_presenter/HighwayItemPresenterSchema';
import {
  IRailwaySchema,
  ETravelType as ERailwayTravelType,
} from '../../../node/repositories/agent-card/entities/railway/RailwaySchema';
import { IAddressItemPresenterSchema } from 'node/repositories/agent-card/entities/address_item_presenter/AddressItemPresenterSchema';
import {
  ELeaseTermType,
  ELeaseType,
  ESaleType,
  IBargainTermsPresenterSchema,
} from 'node/repositories/agent-card/entities/bargain_terms_presenter/BargainTermsPresenterSchema';
import {
  EMaterialType,
  IBuildingPresenterSchema,
} from 'node/repositories/agent-card/entities/building_presenter/BuildingPresenterSchema';
import {
  ECategory,
  EDealType,
  EOfferType,
  IFastFiltersOfferPresenterSchema,
} from 'node/repositories/agent-card/entities/fast_filters_offer_presenter/FastFiltersOfferPresenterSchema';
import { IFastFiltersUserPresenterSchema } from 'node/repositories/agent-card/entities/fast_filters_user_presenter/FastFiltersUserPresenterSchema';
import { IGeoPresenterListItemSchema } from 'node/repositories/agent-card/entities/geo_presenter_list_item/GeoPresenterListItemSchema';
import {
  EAreaUnitType,
  ILandSchema,
  EStatus as EOfferLandStatus,
} from 'node/repositories/agent-card/entities/land/LandSchema';
import { IOfferGroupSchema } from 'node/repositories/agent-card/entities/offer_group/OfferGroupSchema';
import { IPhoneOfferPresenterSchema } from 'node/repositories/agent-card/entities/phone_offer_presenter/PhoneOfferPresenterSchema';
import { IPublicOfferPhotoPresenterSchema } from 'node/repositories/agent-card/entities/public_offer_photo_presenter/PublicOfferPhotoPresenterSchema';
import {
  ETransportType,
  IUndergroundItemPresenterSchema,
} from 'node/repositories/agent-card/entities/underground_item_presenter/UndergroundItemPresenterSchema';

export type { IOfferGroupSchema as IOfferGroup };
export type { IFastFiltersOfferPresenterSchema as IOffer };
export type { IGeoPresenterListItemSchema as IOfferGeo };
export type { IUndergroundItemPresenterSchema as IOfferUnderground };
export type { IHighwayItemPresenterSchema as IOfferHighway };
export type { IRailwaySchema as IOfferRailway };
export type { IAddressItemPresenterSchema as IOfferAddress };
export type { IPhoneOfferPresenterSchema as IOfferPhone };
export type { IFastFiltersUserPresenterSchema as IOfferUserInfo };
export type { IPublicOfferPhotoPresenterSchema as IOfferPhoto };
export type { IBargainTermsPresenterSchema as IOfferBargainTerms };
export type { IBuildingPresenterSchema as IOfferBuilding };
export type { ILandSchema as IOfferLand, EOfferLandStatus };
export { ERailwayTravelType };
export { ETransportType };
export { ECategory };
export { EDealType };
export { EOfferType };
export { EAreaUnitType };
export { ELeaseTermType };
export { ELeaseType };
export { ESaleType };
export { EMaterialType };

export interface IOffersData {
  /** Данные по объявлениям **/
  offers: IOfferGroupSchema[];
  /** Всего объектов **/
  totalCount: number;
}

export const BUILDING_TYPES_PRESENTER: { [key: string]: string } = {
  administrativeBuilding: 'Административное здание',
  businessCenter: 'Бизнес-центр',
  businessCenter2: 'Деловой центр',
  businessPark: 'Бизнес-парк',
  businessQuarter: 'Бизнес-квартал',
  free: 'Свободное',
  freeAppointmentObject: 'Объект свободного назначения',
  industrialComplex: 'Производственный комплекс',
  industrialPark: 'Индустриальный парк',
  industrialSite: 'Промплощадка',
  industrialWarehouseComplex: 'Производственно-складской комплекс',
  logisticsCenter: 'Логистический центр',
  logisticsComplex: 'Логистический комплекс',
  mansion: 'Особняк',
  manufactureBuilding: 'Производственное здание',
  manufacturingFacility: 'Производственный цех',
  modular: 'Модульное здание',
  multifunctionalComplex: 'Многофункциональный комплекс',
  officeAndHotelComplex: 'Офисно-гостиничный комплекс',
  officeAndResidentialComplex: 'Офисно-жилой комплекс',
  officeAndWarehouse: 'Офисно-складское',
  officeAndWarehouseComplex: 'Офисно-складской комплекс',
  officeBuilding: 'Офисное здание',
  officeIndustrialComplex: 'Офисно-производственный комплекс',
  old: 'Старый фонд',
  outlet: 'Аутлет',
  propertyComplex: 'Имущественный комплекс',
  residentialComplex: 'Жилой комплекс',
  residentialFund: 'Жилой фонд',
  residentialHouse: 'Жилой дом',
  shoppingAndBusinessComplex: 'Торгово-деловой комплекс',
  shoppingAndCommunityCenter: 'Торгово-общественный центр',
  shoppingAndEntertainmentCenter: 'Торгово-развлекательный центр',
  shoppingCenter: 'Торговый центр',
  specializedShoppingCenter: 'Специализированный торговый центр',
  standaloneBuilding: 'Отдельно стоящее здание',
  technopark: 'Технопарк',
  tradingOfficeComplex: 'Торгово-офисный комплекс',
  uninhabitedFund: 'Нежилой фонд',
  warehouse: 'Склад',
  warehouseComplex: 'Складской комплекс',
};

type ValueOf<T> = T[keyof T];
export type TSaleTypeValue = ValueOf<typeof ESaleType>;

export const BARGAIN_TERMS_SALE_TYPE_PRESENTER: {
  [index: string]: string;
} = {
  alternative: 'альтернатива',
  dupt: 'переуступка',
  dzhsk: 'договор ЖСК',
  free: 'свободная',
  fz214: '214-ФЗ',
  investment: 'договор инвестирования',
  pdkp: 'предварительный договор',
};

export type TMaterialTypeValue = ValueOf<typeof EMaterialType>;

export const BUILDING_MATERIAL_TYPE_PRESENTER: {
  [index: string]: string;
} = {
  block: 'блочный',
  brick: 'кирпичный',
  monolith: 'монолитный',
  monolithBrick: 'кирпично-монолитный',
  panel: 'панельный дом',
  stalin: 'сталинский',
  wood: 'деревянный',
};

export const BUILDING_QUARTER_PRESENTER: {
  [index: string]: string;
} = {
  first: '1',
  fourth: '4',
  second: '2',
  third: '3',
};

export interface ICoordinates {
  lat: number;
  lng: number;
}

export enum EVas {
  Auction = 'auction',
  Top = 'top3',
  Premium = 'premium',
  Standard = 'standard',
}

export interface IVas {
  type: EVas;
  name: string;
  description: string;
}

export const OFFER_LAND_TYPE: { [key in EOfferLandStatus]: string } = {
  [EOfferLandStatus.Farm]: 'Фермерское хозяйство',
  [EOfferLandStatus.ForAgriculturalPurposes]: 'Участок сельскохозяйственного назначения',
  [EOfferLandStatus.ForestArea]: 'Участок лесного фонда',
  [EOfferLandStatus.Gardening]: 'Садоводство',
  [EOfferLandStatus.GardeningNonProfitPartnership]: 'Садовое некоммерческое товарищество',
  [EOfferLandStatus.IndividualHousingConstruction]: 'Индивидуальное жилищное строительство',
  [EOfferLandStatus.IndustrialLand]: 'Земля промышленного назначения',
  [EOfferLandStatus.IndustryTransportCommunications]:
    'Участок промышленности, транспорта, связи и иного не сельхоз. назначения',
  [EOfferLandStatus.InvestmentProject]: 'Инвестпроект',
  [EOfferLandStatus.OfProtectedCategories]: 'Особо охраняемых категорий',
  [EOfferLandStatus.PrivateFarm]: 'Личное подсобное хозяйство',
  [EOfferLandStatus.Reserve]: 'Участок запаса',
  [EOfferLandStatus.Settlements]: 'Участок поселений',
  [EOfferLandStatus.SuburbanNonProfitPartnership]: 'Дачное некоммерческое партнерство',
  [EOfferLandStatus.SuburbanNonProfitSettlementsPartnership]: 'Дачное некоммерческое партнерство поселений',
  [EOfferLandStatus.WaterArea]: 'Участок водного фонда',
};
